import React from 'react';
import share from '../../../assets/sso/share.svg';
import ia from '../../../assets/sso/ia.svg';
import choice from '../../../assets/sso/choix.svg';
import archive from '../../../assets/sso/ico_archivage 1.svg';
import secure from '../../../assets/secure.svg';
import { RootState } from '../../../rootReducer';
import { useSelector } from 'react-redux';

const InfoAdmin: React.FC = () => {
    const isSsoUser = useSelector((state: RootState) => state.user.isSsoUser);

    return (
        <div className="flex justify-around items-center px-2 md:px-5 pb-4 md:pb-6 pt-3 md:pt-5 gap-2 sm:gap-4 lg:gap-8 m-auto font-medium w-full">
            <div className="flex-shrink-0">
                <p className="text-white text-sm sm:text-base md:text-lg lg:text-[22px] pt-[10px] leading-tight">
                    <span className="text-black">
                        Grâce à<br />
                        votre espace,
                    </span>
                    <br />
                    vous pouvez
                </p>
            </div>
            <div className="flex-shrink min-w-0">
                <img
                    className="w-[18px] h-[18px] sm:w-[20px] sm:h-[20px] md:w-[24px] md:h-[24px]"
                    src={share}
                    alt="share icon"
                />
                {isSsoUser ? (
                    <p className="text-white text-xs sm:text-sm md:text-medium pt-[10px] leading-tight">
                        Gérer la diffusion
                        <br />
                        des contenus
                        <br />
                        Newsfactory
                    </p>
                ) : (
                    <p className="text-white text-xs sm:text-sm md:text-medium pt-[10px] leading-tight">
                        Diffuser du
                        <br />
                        contenu au sein
                        <br />
                        de votre réseau
                    </p>
                )}
            </div>
            <div className="flex-shrink min-w-0">
                <img
                    className="w-[18px] h-[18px] sm:w-[20px] sm:h-[20px] md:w-[24px] md:h-[24px]"
                    src={ia}
                    alt="ia icon"
                />
                {isSsoUser ? (
                    <p className="text-white text-xs sm:text-sm md:text-medium pt-[10px] leading-tight">
                        Créer vos
                        <br />
                        publications
                        <br />
                        avec l'IA
                    </p>
                ) : (
                    <p className="text-white text-xs sm:text-sm md:text-medium pt-[10px] leading-tight">
                        Créer & planifier
                        <br />
                        vos publications
                        <br />
                        avec l'IA
                    </p>
                )}
            </div>
            <div className="flex-shrink min-w-0">
                {isSsoUser ? (
                    <>
                        <img
                            className="w-[18px] h-[18px] sm:w-[20px] sm:h-[20px] md:w-[24px] md:h-[24px]"
                            src={choice}
                            alt="choice icon"
                        />
                        <p className="text-white text-xs sm:text-sm md:text-medium pt-[10px] leading-tight">
                            Sélectionner les
                            <br />
                            réseaux de
                            <br />
                            diffusion
                        </p>
                    </>
                ) : (
                    <>
                        <img
                            className="w-[18px] h-[18px] sm:w-[20px] sm:h-[20px] md:w-[24px] md:h-[24px]"
                            src={archive}
                            alt="archive icon"
                        />
                        <p className="text-white text-xs sm:text-sm md:text-medium pt-[10px] leading-tight">
                            Gérer la diffusion
                            <br />
                            des contenus
                            <br />
                            Newsfactory
                        </p>
                    </>
                )}
            </div>
            <div className="flex-shrink min-w-0">
                {isSsoUser ? (
                    <>
                        <img
                            className="w-[18px] h-[18px] sm:w-[20px] sm:h-[20px] md:w-[24px] md:h-[24px]"
                            src={archive}
                            alt="archive icon"
                        />
                        <p className="text-white text-xs sm:text-sm md:text-medium pt-[10px] leading-tight">
                            Consulter tous
                            <br />
                            vos derniers
                            <br />
                            posts
                        </p>
                    </>
                ) : (
                    <>
                        <img
                            className="w-[18px] h-[18px] sm:w-[20px] sm:h-[20px] md:w-[24px] md:h-[24px]"
                            src={secure}
                            alt="secure icon"
                        />
                        <p className="text-white text-xs sm:text-sm md:text-medium pt-[10px] leading-tight">
                            Suivre l'état des
                            <br />
                            connexions de
                            <br />
                            mon réseau
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};

export default InfoAdmin;
